
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { HarvestFormValues } from './schema';

interface FormActionsProps {
  form: UseFormReturn<HarvestFormValues>;
  isEditMode: boolean;
  farmId?: string;
}

const FormActions: React.FC<FormActionsProps> = ({ form, isEditMode, farmId }) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex gap-4 justify-end">
      <Button 
        type="button" 
        variant="outline" 
        onClick={() => farmId ? navigate(`/farms/${farmId}`) : navigate('/harvests')}
        disabled={form.formState.isSubmitting}
      >
        Cancel
      </Button>
      <Button 
        type="submit" 
        disabled={form.formState.isSubmitting}
      >
        {form.formState.isSubmitting ? (
          <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Saving...</>
        ) : (
          isEditMode ? 'Update Harvest' : 'Create Harvest'
        )}
      </Button>
    </div>
  );
};

export default FormActions;
